export enum GenderType {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER',
}

export enum AIStatus {
  UNVERIFIED = 'unverified',
  VERIFIED = 'verified',
}
